import { render } from "./index.vue?vue&type=template&id=2507c3d2"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2507c3d2&lang=less"
script.render = render

export default script